.card {
    margin: 16px;
}

.cardBody {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
}

.logo {
    width: 80%;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.heading {
    width: 100%;
    margin-top: 1rem;
}

.newPasswordFeedbackText {
    width: 300px;
    text-align: center;
    margin: 0.25rem auto auto auto;
}

.submitButton {
    align-self: flex-end;
}
